export const changeMonitoringLevel3Reducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_MonitoringLevel3":
      return action.payload.MonitoringLevel3;
    default:
      return state;
  }
};
